import { render } from "./globaldialog.vue?vue&type=template&id=dd227728"
import script from "./globaldialog.vue?vue&type=script&lang=js"
export * from "./globaldialog.vue?vue&type=script&lang=js"

import "./globaldialog.vue?vue&type=style&index=0&id=dd227728&lang=less"

import exportComponent from "/Users/aa/work/credit_chakra_ios/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__